<template>
  <div>
    <div v-if="submit_loader"
         style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255, 255, 255, 0.31)">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>

      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form
                id="create_announcement"
                @submit.prevent="validateBeforeSubmit('createAnnouncement')"
                data-vv-scope="createAnnouncement"
                ref="announcement_form"
                v-model="valid"
            >
              <v-card-text>
                <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                  <v-layout row wrap>
                    <v-flex xs12 md8 lg4>
                      <label>Service Alert Type</label>
                      <v-autocomplete
                          :items="announcement_types"
                          name="Service Alert Type"
                          label="Select Service Alert Type"
                          v-model="announcement_object.type"
                          return-object
                          item-text="title"
                          @change="resetInput"
                          item-value="id"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createAnnouncement.Service Alert Type')"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md8 lg4>
                      <label>City Name</label>
                      <v-autocomplete
                          :items="cityList"
                          name="City Name"
                          label="Select City"
                          v-model="announcement_object.city_id"
                          item-text="name"
                          item-value="id"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createAnnouncement.City Name')"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Local Line </label>
                      <v-autocomplete
                          :items="city_vise_local_lines"
                          name="Local Line"
                          v-model="announcement_object.local_line"
                          return-object
                          :item-text="code_with_name"
                          item-value="id"
                          label="Select Local Line"
                          filled
                          chips
                          multiple
                          solo flat :menu-props="{closeOnContentClick:true}">
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Title </label>
                      <v-text-field
                          name="Title"
                          v-model="announcement_object.title"
                          label="Title"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createAnnouncement.Title')"
                          clearable
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Description: </label>
                      <v-textarea
                          name="Description"
                          v-model="announcement_object.description"
                          rows="2"
                          label="Description"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createAnnouncement.Description')"
                          clearable
                      >
                      </v-textarea>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md8 lg8 style="display: flex; flex-wrap: wrap;">
                      <v-flex xs12 md6 lg5 class="dateCSS">
                        <label>Relevant From: </label>
                        <div style="padding-bottom: 23px !important;">
                          <flat-pickr
                              class="flatpickerCSS2"
                              v-model="announcement_object.relevant_from"
                              :config="config"
                              placeholder="Date" v-validate="'required'"
                              :error-messages="errors.collect('createAnnouncement.Relevant from')"
                              name="Relevant from"/>
                        </div>
                      </v-flex>

                      <v-flex xs12 md6 lg5>
                        <label>Relevant To: </label>
                        <div style="padding-bottom: 23px !important;">
                          <flat-pickr
                              class="flatpickerCSS2"
                              label="Relevant To"
                              v-model="announcement_object.relevant_to"
                              :config="config"
                              placeholder="Date" v-validate="'required'"
                              :error-messages="errors.collect('createAnnouncement.Relevant to')"
                              name="Relevant to"/>
                        </div>
                      </v-flex>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md8 lg8 style="display: flex; flex-wrap: wrap; padding-bottom: 20px !important;">
                      <v-flex xs12 sm6 md6 lg5 style="padding-bottom: 5px !important;">
                        <label>Upload Image</label>
                        <input type="file" name="image_path" id="image_path" class="form-control flatpickerCSS2"
                               v-on:change="imageSelected" v-validate="'ext:jpg,jpeg,png'">
                        <span style="font-size: 11px;">(Allowed file types: jpg,jpeg,png)</span>
                        <span class="red--text pt-3" v-if="errors.has('createAnnouncement.image_path') &&
                        errors.collect('createAnnouncement.image_path').length > 0">
                          {{ errors.collect('createAnnouncement.image_path')[0] }}
                        </span>
                        <span v-else></span>
                      </v-flex>

                      <v-flex xs12 sm6 md6 lg3 class="ImageDisplay" v-if="announcement_object.previewImage != ''"
                              style="flex-wrap: wrap; flex-direction: column; align-items:center; justify-content: space-around; align-content: space-around;">
                        <v-flex xs12 sm12 md12 lg12
                                style="height: auto; width: auto; align-content: center;">
                          <div v-if="announcement_object.previewImage" class="mt-3">
                            <img :src="announcement_object.previewImage" class="figure-img img-fluid rounded"
                                 style="max-height:100px;">
                          </div>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12>
                          <v-btn icon @click="clearImage()">
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-flex>

                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md12 lg8 style="display: flex;">
                      <v-flex xs12 md4 lg4>
                        <v-checkbox
                            v-model="announcement_object.is_scheduled"
                            label="Is Scheduled"
                        ></v-checkbox>
                      </v-flex>

                      <v-flex xs12 md8 lg8 v-if="announcement_object.is_scheduled == 1">
                        <label>Scheduled At: </label>
                        <div style="padding-bottom: 23px !important;">
                          <flat-pickr
                              class="flatpickerCSS2"
                              label="Scheduled At"
                              v-model="announcement_object.scheduled_at"
                              :config="config"
                              placeholder="Schedule Date & Time" v-validate="'required'"
                              :error-messages="errors.collect('createAnnouncement.Scheduled At')"
                              name="Scheduled At"/>
                        </div>
                      </v-flex>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Body: </label>
                      <!--                      <VueEditor  name="Announcement Body"-->
                      <!--                                  v-model="announcement_object.body"-->
                      <!--                                  label="Announcement Body" ref="myQuillEditor"-->
                      <!--                                  solo flat/>-->

                      <quill-editor ref="myQuillEditor"
                                    name="Announcement_Body"
                                    :value="announcement_object.body"
                                    :options="quillOptions"
                                    label="Announcement Body"
                                    solo flat @input="updateBody"/>
<!--                      @input="updateBody"-->
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="!valid || announcement_object.title == '' ||
                (announcement_object.is_scheduled == 1 && announcement_object.scheduled_at == '')"
                       type="submit">Create
                </v-btn>
                <v-btn flat small to="/announcements">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>

      <v-snackbar
          :color="snackBar.color"
          :top="snackBar.top"
          :bottom="snackBar.bottom"
          :left="snackBar.left"
          :right="snackBar.right"
          v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  created() {
  },
  computed: {
    // workspaceRequestCode:function(){
    //  return this.announcement_object.office_id.name + '/'+ this.announcement_object.tower_id.name + '/' + this.announcement_object.wing_id.name +'/'+this.announcement_object.type+'/'+this.announcement_object.number;
    // }
  },

  components: {
    // VueEditor,
    flatPickr,
    quillEditor
  },
  watch: {
    "announcement_object.train_code": {
      handler() {
        if (this.announcement_object.type.id == 1 || this.announcement_object.type.id == 5) {
          if (this.announcement_object.train_code != '') {
            this.is_populate = true;
          }
        }
      }
    },
    "announcement_object.type": {
      handler() {
        // this.announcement_object.show_in_search = false;
        this.announcement_object.relevant_from = null;
        this.announcement_object.relevant_to = null;
        this.announcement_object.date = null;
        if (this.announcement_object.type.id == 2) {
          this.announcement_object.relevant_from = moment().format("YYYY-MM-DD H:m:00");
          this.announcement_object.relevant_to =
              (moment()).format('YYYY-MM-DD 18:00:00');
          // (moment().clone().weekday(0).add(1, 'weeks')).format('YYYY-MM-DD H:m:00');
        }
        if (this.announcement_object.type.id == 4 || this.announcement_object.type.id == 5) {
          this.announcement_object.relevant_from = moment().format("YYYY-MM-DD H:m:00");
          this.announcement_object.relevant_to = (moment().add(3, 'hours')).format('YYYY-MM-DD H:m:00');
        }


        if (this.announcement_object.type.id == 1 || this.announcement_object.type.id == 3) {
          this.show_search = false;
        } else {
          this.show_search = true;
        }
      }
    },
    "announcement_object.local_line": function (val) {

      if (val == '' || val == null) {
        this.announcement_object.title = '';
        this.announcement_object.description = '';
      }
      if (this.announcement_object.type.id == 2) {
        if (val && val.length > 0) {
          const LineArray = [];
          const LineCode = [];

          val.forEach((element) => {
            if (element.id == 0) {
              this.local_lines.forEach((element_cr) => {
                if (!LineArray.includes(element_cr.name) && !LineCode.includes(element_cr.code)) {
                  if (element_cr.id != 0) {
                    if (element_cr.division_code == 'cr_mumbai') {
                      LineArray.push(element_cr.name);
                      LineCode.push(element_cr.code);
                    }
                  }
                }
              });
            } else {
              if (!LineArray.includes(element.name) && !LineCode.includes(element.code)) {
                if (element.id != 0) {
                  LineArray.push(element.name);
                  LineCode.push(element.code);
                }
              }
            }
          });

          let lineName = (LineArray).join(', ');
          this.announcement_object.title = "Megablock on " + lineName + " line on " + (moment().clone().weekday(0).add(1,
              'weeks')).format('dddd, Do MMMM');

          let Name = "";
          if (LineCode.includes('WS')) {
            Name = "Western";
          } else if (LineCode.includes('MAIN') || LineCode.includes('HARB') || LineCode.includes('TRANS') ||
              LineCode.includes('BSU') || LineCode.includes('PNVL-BSR') ||
              LineCode.includes('NRL-MAE')) {
            Name = "Central";
          }

          this.announcement_object.description = Name + " Railways will operate Megablock on " +
              (moment().clone().weekday(0).add(1, 'weeks')).format('dddd, Do MMMM') + ". Check here for more details..."
        }
      }

    },
    "announcement_object.relevant_from": function (val) {
      if (val != '' || val != null) {
        if (val && (this.announcement_object.type.id == 2 || this.announcement_object.type.id == 4 ||
            this.announcement_object.type.id == 5)) {
          this.announcement_object.show_from = val;
        }
      }
    },
    "announcement_object.relevant_to": function (val) {
      if (val != '' || val != null) {
        if (val && (this.announcement_object.type.id == 2 || this.announcement_object.type.id == 4 ||
            this.announcement_object.type.id == 5)) {
          this.announcement_object.show_till = val;
        }

      }
    },
    "announcement_object.is_scheduled": function (val) {
      if (val == false) {
        this.announcement_object.scheduled_at = "";
      }
    },
    "announcement_object.body": function (val){
      if(val == '' || val != null){
        setInterval(this.handleTextChange, 1000);
      }
    },
    "announcement_object.city_id": function (val){
      this.city_vise_local_lines = [];
      if(val != '' || val != null){
        this.local_lines.forEach((item) =>{
          if(item.city_id == val) {
            this.city_vise_local_lines.push(item);
          }
        })
      }else{
        this.local_lines.forEach((item) =>{
            this.city_vise_local_lines.push(item);

        })
      }
    }
  },
  methods: {
    resetInput() {
      this.announcement_object.title = "";
      this.announcement_object.local_line = "";
      this.announcement_object.description = "";
      this.announcement_object.is_scheduled = 0;
      this.announcement_object.scheduled_at = "";
      return;
    },
    // create_announcement: function () {
    //   this.submit_loader = true;
    //   const announcement_type_id = this.announcement_object.type.id;
    //   let new_announcement = Object.assign({}, this.announcement_object);
    //   new_announcement.announcement_type_id = this.announcement_object.type.id;
    //
    //
    //   axios.post(`${process.env.VUE_APP_API_URL}/api/v1/announcement-template`, new_announcement, {headers: this.$headers})
    //       .then((response) => {
    //         if (response.data.status == 1) {
    //           this.announcement_object.title = response.data.title;
    //           this.announcement_object.description = response.data.description;
    //           this.announcement_object.local_line = response.data.local_line;
    //           if (this.announcement_object.type.id == 1 || this.announcement_object.type.id == 3) {
    //             this.announcement_object.relevant_from = response.data.start;
    //             this.announcement_object.relevant_to = response.data.last;
    //           }
    //           this.submit_loader = false;
    //         }
    //
    //       }).catch((error) => {
    //     console.log(error);
    //   }).finally(() => {
    //     this.submit_loader = false;
    //   });
    // },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    createAnnouncement: function () {
      this.submit_loader = true;
      let new_announcement = Object.assign({}, this.announcement_object);

      new_announcement.title = this.announcement_object.title;
      new_announcement.description = this.announcement_object.description;
      new_announcement.type = this.announcement_object.type.id;
      // new_announcement.local_line = this.announcement_object.local_line;
      new_announcement.body = this.announcement_object.body;
      new_announcement.is_notify = this.announcement_object.is_notify;
      new_announcement.is_scheduled = this.announcement_object.is_scheduled;
      new_announcement.scheduled_at = this.announcement_object.scheduled_at;
      new_announcement.city_id = this.announcement_object.city_id;

      let local_line_list = [];
      this.announcement_object.local_line.forEach((element) => {
        if (element.id == 0) {
          this.local_lines.forEach((element_cr) => {
            if (element_cr.division_code == 'cr_mumbai') {
              if (!local_line_list.includes(element_cr.id)) {
                local_line_list.push(element_cr);
              }
            }
          });
        } else {
          if (!local_line_list.includes(element.id)) {
            local_line_list.push(element);
          }
        }
      });

      new_announcement.local_line = Array.from(new Set(local_line_list.map(obj => obj.id))).map(id => {
        return local_line_list.find(obj => obj.id === id);
      });

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/add-announcement`, new_announcement,
          {'Content-Type': 'multipart/form-data'}).then((response) => {

        if (response.data.status == 1) {
          var announcement = response.data.announcement;
          this.$router.push('/announcements/' + announcement.id);
          this.submit_loader = false;
        } else if (response.data.status == 2) {
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
          this.$validator.reset();
          // this.$refs.announcement_form.reset();
        } else {
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
        }

      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.submit_loader = false;
      });

    },
    getTypeList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/announcement-types`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.announcement_types = response.data.types;
              this.announcement_object.type = this.announcement_types[0];
            }

          })
    },
    getTrainCodes: function () {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-codes`,
          {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.train_codes = response.data.train_codes;
            }

          })

    },
    getLocalLineList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/local-lines`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {

              // if (this.$store.getters.get_user.roles[0].name == 'cr_cpro_user' ||
              //     this.$store.getters.get_user.roles[0].name == 'cr_controlroom_user' ||
              //     this.$store.getters.get_user.roles[0].name == 'admin') {
              this.local_lines.push({'code': "All CR Mumbai Division", 'name': "all_CR_mumbai_division", 'id': 0});
              // }
              response.data.local_lines.forEach((element) => {
                if (element.id == 2) {
                  if (this.$store.getters.get_user.roles[0].name == 'cr_cpro_user' ||
                      this.$store.getters.get_user.roles[0].name == 'cr_controlroom_user') {
                  } else {
                    // if (element.id == 8) {
                    // } else {
                      this.local_lines.push(element);
                    // }
                  }
                } else {
                  // if (element.id == 8) {
                  // } else {
                    this.local_lines.push(element);
                  // }
                }
              });

              this.city_vise_local_lines = this.local_lines;
            }
          })
    },
    getItemText(item) {
      return `${item.number} - ${item.short_code}`;
    },
    imageSelected(e) {
      this.image_path = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.image_path);
      reader.onload = e => {
        this.announcement_object.previewImage = e.target.result;
      };
    },
    clearImage() {
      this.announcement_object.previewImage = '';
      this.image_path = '';
      $('#image_path').val('');

      const index = this.errors.items.findIndex(item => item.field == 'image_path');
      if (index !== -1) {
        this.errors.items.splice(index, 1);
      }
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    handleTextChange() {
          if(this.announcement_object.body != null || this.announcement_object.body == ''){
            const containsImages = this.announcement_object.body.includes('<img');
            if (containsImages) {
              const imageData = this.announcement_object.body.match(/<img[^>]+src="([^">]+)"/g);

              imageData.forEach((element) => {
                const srcMatch = element.match(/src="([^"]+)"/);

                let Image_data = srcMatch[1];
                if (Image_data.startsWith('data:image/png;base64,') ||
                    Image_data.startsWith('data:image/jpg;base64,') ||
                    Image_data.startsWith("data:image/jpeg;base64,")) {
                  axios.post(`${process.env.VUE_APP_API_URL}/api/v1/add-image-to-azure`, {Image_data})
                      .then(response => {
                        if (response.data.status == 1) {
                          this.azure_image_path = response.data.data;
                          const new_UrL = process.env.VUE_APP_AZURE_STORAGE_URL +
                          process.env.VUE_APP_AZURE_STORAGE_CONTAINER + '/' + this.azure_image_path;

                          const escapedOldSrc =  this.escapeRegExp(srcMatch[1]); //RegExp.escape(srcMatch[1]);
                          const regex = new RegExp(`<img src="${escapedOldSrc}"`, 'g');
                          this.announcement_object.body =
                              this.announcement_object.body.replace(regex, `<img src="${new_UrL}"`);
                        }
                      })
                }
              });
            }
        }
    },
    updateBody(value) {
      this.$set(this.announcement_object, 'body', value);
    },
    getCityList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name':"ALL"})
            }
          });
    },
    code_with_name(item){
      return `${item.code} - ${item.name}`;
    }
    // updateBodyTag(value) {
      // this.announcement_object.body =
      //     this.announcement_object.body.replace(/<img[^>]+src="([^">]+)"/g,
      //     // `<img src="${value}"`);
    // }
  },
  data: () => {
    return {
      show_search: true,
      config: {
        enableTime: true,
        altInput: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: false,
        minDate: moment().format('YYYY-MM-DD'),
        maxDate: moment().add(45, 'days').format('YYYY-MM-DD')
      },
      announcement_object: {
        local_line: [],
        title: "",
        type: "",
        train_code: "",
        description: "",
        body: '',
        date: null,//(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        show_in_search: true,
        is_notify: true,
        relevant_to: null,
        relevant_from: null,
        previewImage: '',
        is_scheduled: 0,
        scheduled_at: '',
        city_id: 0
      },
      image_path: '',
      fileExtension: '',
      is_populate: false,
      submit_loader: false,
      valid: false,
      title_content: '',
      description_content: '',
      floor_list: [],
      announcement_types: [],
      train_codes: [],
      local_lines: [],
      city_vise_local_lines: [],
      tower_list: [],
      wing_list: [],
      cityList: [],
      auth_user: {
        roles: [{}]
      },
      workspaceRequestCode: "",
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false
      },
      htmlForEditor: "",
      quillOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['link'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['blockquote', 'code-block'],
            [{'header': 1}, {'header': 2}],
            [{'script': 'sub'}, {'script': 'super'}],
            [{'indent': '-1'}, {'indent': '+1'}],
            [{'direction': 'rtl'}],
            [{'size': ['small', false, 'large', 'huge']}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            ['clean'],
            ['image']
          ]
        },
        theme: 'snow'
      },
      azure_image_path: '',
    }
  },
  mounted() {
    this.getCityList();
    this.getLocalLineList();
    this.getTypeList();
    // this.getTrainCodes();
  },
  // beforeDestroy() {
  //   this.editor.destroy();
  // }
};
</script>
<!--<style>-->
<!--.ql-container.ql-snow {-->
<!--  max-height: 300px !important;-->
<!--  overflow: auto !important;-->
<!--}-->
<!--</style>-->
